// extracted by mini-css-extract-plugin
module.exports = {"label":"rdg_9b9c9f01"};